import { render, staticRenderFns } from "./CommonImage.vue?vue&type=template&id=62d8530c&"
import script from "./CommonImage.vue?vue&type=script&lang=js&"
export * from "./CommonImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports